import React from 'react';
import { LoginScreenDesktop } from './LoginScreenDesktop';
import { LoginScreenMobile } from './LoginScreenMobile';

export const LoginScreen = () => {
  console.log("LoginScreen component rendering");
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    console.log("LoginScreen useEffect running");
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  console.log("LoginScreen about to render:", isMobile ? "mobile" : "desktop");
  return isMobile ? <LoginScreenMobile /> : <LoginScreenDesktop />;
};
